// @flow

import { get } from 'lodash';

import { refetchQueriesByName as refetchQueries } from 'app/common/apollo/refetchQueries';

import type { ApolloClient } from 'apollo-client';

import type { ApolloResult } from 'app/common/apollo/types';

/**
 * Creates a stringified version of the GraphQL query name and the variables
 * provided for that query.
 */
export const createCacheKey = (queryName: string, variables: Object) => {
  if (!queryName) {
    throw new Error(
      'Cannot create a cache key without a query name. Cached queries must be named queries.'
    );
  }

  // This will return alpha sorted [key, value] pairs of the variables used
  // in the request. Because properties order in objects in not guaranteed
  // in JS, we need to ensure that the keys generated will always be the same
  // given the same arguments.
  const keyValueVariables = Object.entries(variables);
  const alphaOrderKeys = keyValueVariables.sort((a, b) => {
    if (a[0] < b[0]) return -1;
    if (a[0] > b[0]) return 1;
    return 0;
  });

  return `${queryName}:${JSON.stringify(alphaOrderKeys)}`;
};

export const refetchQueriesByName = (
  queryNames: Array<string>,
  client: ApolloClient<*>
): Promise<any> => refetchQueries(client, queryNames);

export const extractErrorMessages = (result: ApolloResult) => {
  const error = get(result, ['error', 'networkError']);
  const messages = get(error, ['result', 'errors']);
  return messages || get(error, ['message']);
};
